import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70167f96"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "typing" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "point" }),
  /*#__PURE__*/_createElementVNode("div", { class: "point two" }),
  /*#__PURE__*/_createElementVNode("div", { class: "point three" })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ 'background' : _ctx.background}),
    id: "filter"
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({'width': _ctx.width, 'height' : _ctx.width}),
      class: "water",
      id: "container"
    }, _hoisted_2, 4)
  ], 4))
}